// REGEX
export const zipCodeRegex = /^\d{5}(?:[-\s]\d{4})?$/;

export const dealNameRegex = /([\w'\s-]+): ([\w'\s,-]+): ([\w'\s,-]+)/;

export const integerRegex = /^\d+$/;

export const selectIntegersRegex = /[^0-9]/g;

export const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
export const verifyEmailRegex = (email) => {
	return emailRegex.test(email);
};

// regex for not starting or ending with a space
export const noSpaceRegex = /^\S(.*\S)?$/;
